import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "calculator__skill tooltip-anchor"
}
const _hoisted_2 = { class: "calculator__tooltip-desc-block" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "calculator__counter-block" }
const _hoisted_5 = { class: "calculator__bars-wrapper" }
const _hoisted_6 = { class: "calculator__cost-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.hasTag())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_TooltipComponent, {
          width: 25,
          class: "calculator__tooltip",
          color: 'dark'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skill.progression, (progression, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: progression }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.skill.curLvl == index + 1 ? _ctx.branchColor : '')
                  }, _toDisplayString(progression), 3),
                  _createElementVNode("span", null, _toDisplayString(index == _ctx.skill.progression.length - 1 ? '' : ' / '), 1)
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skill.desc.split(';'), (desc) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: desc,
                  class: "calculator__tooltip-desc"
                }, _toDisplayString(desc), 1))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createElementVNode("img", {
          src: require('@/assets/skill_icons/' + _ctx.skill.icon),
          alt: "",
          class: _normalizeClass(["calculator__img", { [_ctx.branchColor]: _ctx.skill.curLvl }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickHandle('plus'))),
          onContextmenu: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.clickHandle('minus')), ["prevent"]))
        }, null, 42, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn calculator__button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickHandle('minus')))
          }, [
            _createVNode(_component_IconBase, {
              height: _ctx.$store.state.settings.compactMode ? 12 : 16,
              width: _ctx.$store.state.settings.compactMode ? 12 : 16
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconMinus)
              ]),
              _: 1
            }, 8, ["height", "width"])
          ])), [
            [_directive_ripple]
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skill.maxLvl, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["calculator__bar", {
						'calculator__bar-highlight': index < _ctx.skill.curLvl,
						[_ctx.branchColor]: true,
					}]),
                key: item
              }, "   ", 2))
            }), 128))
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn calculator__button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickHandle('plus')))
          }, [
            _createVNode(_component_IconBase, {
              height: _ctx.$store.state.settings.compactMode ? 12 : 16,
              width: _ctx.$store.state.settings.compactMode ? 12 : 16
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconPlus)
              ]),
              _: 1
            }, 8, ["height", "width"])
          ])), [
            [_directive_ripple]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skill.maxLvl, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
              _createElementVNode("span", {
                class: _normalizeClass({ [_ctx.branchColor]: _ctx.skill.curLvl == index + 1 })
              }, _toDisplayString((index + 1) * _ctx.skill.costPerLvl), 3),
              _createElementVNode("span", null, _toDisplayString(index == _ctx.skill.maxLvl - 1 ? '' : '/'), 1)
            ], 64))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}